import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card } from "react-bootstrap";
import temp1 from "../../../assets/img/template.png";
import temp2 from "../../../assets/img/Template1.png";
import editor from "../../../assets/img/PlusAIcvmakerlogo.png";
import "./TemplateList.css";

const TemplateList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const templates = [
    { name: "editor", img: editor },
    { name: "template1", img: temp1 },
    { name: "template2", img: temp2 },
    { name: "template3", img: temp1 },
    { name: "cvthemeone", img: temp2 },
    { name: "stylishresume", img: temp1 },
    { name: "template6", img: temp2 },
  ];

  return (
    <div className="template-sidebar">
      {templates.map((template, index) => {
        const isActive = location.pathname.includes(template.name);

        return (
          <Card
            key={index}
            className={`template-card ${isActive ? "active-card" : ""}`} // Add active class if selected
            onClick={() => navigate(`/dashboard/templatelist/${template.name}`)}
          >
            <Card.Img variant="top" src={template.img} loading="lazy" />
          </Card>
        );
      })}
    </div>
  );
};

export default TemplateList;
